let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7Qxu7")).then(() => parcelRequire('ffPxZ'));